<template>
  <div class="hr-field-view">
    <span class="hr-field-view__title">
      {{ label }}
      <sup>
        {{ requiredSuffix }}
      </sup>
    </span>
    <span class="hr-field-view__value fs-mask">
      {{ formattedValue }}
    </span>
  </div>
</template>

<script>
import t from '@/lib/i18next';
import { QUESTION_VALUE_TYPES } from '@/core/input-types/custom_questions';

export default {
  name: 'hr-field-question-view',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const label = props.value?.questionValue?.question || '';
    const isRequiredQuestion = props.value?.questionValue?.isRequired ?? false;
    const requiredSuffix = isRequiredQuestion ? '*' : '';
    const formattedValue = formatQuestionValue(props.value);

    function hasFullStopInAnswer(answer) {
      if (!answer) {
        return false;
      }
      return answer.slice(answer.length - 1) === '.';
    }

    function hasResponseArray(field) {
      return (
        field?.questionValue?.responses &&
        Array.isArray(field.questionValue.responses) &&
        field.questionValue.responses.length
      );
    }

    function formatQuestionValue(field) {
      if (!hasResponseArray(field)) {
        return isRequiredQuestion ? '' : t('hr-field-view:not-provided');
      }

      const { questionValue } = field;

      const { answer = '', comment = '' } = questionValue?.responses[0];
      let separator =
        props.value?.questionValue.type === QUESTION_VALUE_TYPES.YESNO
          ? ', '
          : !hasFullStopInAnswer(answer)
          ? '. '
          : ' ';
      if (!answer) {
        separator = '';
      }

      let value = answer + (comment ? `${separator}${comment}` : '');
      if (!answer && !comment) {
        value = t('hr-field-view:not-provided');
      }

      return value;
    }

    return {
      label,
      requiredSuffix,
      formattedValue,
    };
  },
};
</script>
